<template>
  <div class="bottom-gradient">
    <span class="gradient-line primary" />
    <span class="gradient-line blur" />
  </div>
</template>

<script>
export default {
  name: 'BottomGradient',
};
</script>

<style lang="scss">
.bottom-gradient {
  position: relative;
}

.gradient-line {
  position: absolute;
  height: 1px;
  bottom: -1px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  background: linear-gradient(to right, transparent, #6cd608, transparent); // via-nexa_lime
  pointer-events: none;

  &.blur {
    width: 50%;
    left: 25%;
    filter: blur(4px);
    background: linear-gradient(to right, transparent, #6cd608, transparent); // lime-700
  }
}

.btn-gradient-hover:hover + .bottom-gradient .gradient-line,
.btn-gradient-hover:focus + .bottom-gradient .gradient-line {
  opacity: 1;
}
</style>
